import { BaseText, Title } from 'aimo-ui';
import SvgImage from 'components/svgImage/SvgImage';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';

const NoChargersFound = () => {
  const { t } = useTranslation();
  return (
    <StyledWrapper center mt={30}>
      <StyledWrapper center ml={-30}>
        <SvgImage name="Charger" width={112} height={111} />
      </StyledWrapper>
      <StyledWrapper />
      <StyledWrapper center maxWidth={250}>
        <Title center>{t('evCharging.chargerNotFoundTitle')}</Title>
      </StyledWrapper>
      <StyledWrapper>
        <BaseText center maxWidth={340} mt={10}>
          {t('evCharging.chargerNotFoundDesc')}
        </BaseText>
      </StyledWrapper>
    </StyledWrapper>
  );
};

export default NoChargersFound;
